export const ZOOM_STEPS = [0.5, 1, 3, 5, 10, 20, 50]
export const TRACK_HEIGHT = 25
export const ENTITY_HEIGHT = 15
export const HANDLES_BRIGHTNESS = 15 // tinycolor2 brigntness argument (0-100)
export const GRID_SIZE = 25
